import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {NotificationService} from "../Services/notification.service";

@Component({
    selector: 'notification',
    templateUrl: 'notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent implements OnChanges {

  @Input() severity: string;
  @Input() timeout: number;
  @Input() message: string;
  // eslint-disable-next-line @angular-eslint/no-output-rename, @angular-eslint/no-output-on-prefix
  @Output('hideNotification') onClose: EventEmitter<any> = new EventEmitter();

  className: string;
  displayNotif = false;

  constructor(private readonly notificationService: NotificationService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.severity === 'warning') {
      this.className = 'notif notif-warning';
    } else if (this.severity === 'info') {
      this.className = 'notif notif-info';
    } else {
      this.className = 'notif notif-error';
    }
    this.displayNotif = true;
    if (this.timeout) {
      this.displayNotif = true;
      setTimeout(() => {
        this.displayNotif = false;
        this.onClose.next(true);
        this.deleteContent();
      }, this.timeout);
    }

  }

  private deleteContent() {
    this.notificationService.setMessage(null);
    this.notificationService.setType(null)
  }
}
